<template>
  <div class="workbenchBank">
    <van-form
      label-width="120px"
      :show-error="false"
      :scroll-to-error="false"
      @submit="onSubmit"
    >
      <van-field
        v-model="form.BankAccountName"
        :label="$t.workbench.accountName"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.BankAccount"
        :label="$t.workbench.accountNo"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />

      <van-field
        v-model="form.BankName"
        :label="$t.workbench.bankName"
        :placeholder="$t.information.input"
        required
        :rules="formRule"
      />

      <van-field :label="$t.workbench.qrcode" required :rules="formRule">
        <template #input>
          <van-uploader
            v-model="electronicWalletQrCode"
            :max-count="1"
            :after-read="afterRead1"
          />
        </template>
      </van-field>

      <div style="padding: 16px; margin-bottom: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.workbench.saveBankInfo
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Uploader } from "vant";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Uploader);

export default {
  name: "workbenchBank",
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      electronicWalletQrCode: [],
    };
  },
  created() {
    var data = JSON.parse(localStorage.getItem("workbenchBank"));
    this.form = data;
    this.firstLoad();
  },
  methods: {
    firstLoad() {
      if (this.form.ElectronicWalletQrCode) {
        this.electronicWalletQrCode.push({
          url: this.imgUrlFilter(this.form.ElectronicWalletQrCode),
        });
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        ElectronicWalletQrCode: this.form.ElectronicWalletQrCode,
        BankAccountName: this.form.BankAccountName,
        BankAccount: this.form.BankAccount,
        BankName: this.form.BankName,
      };
      this.$api.user
        .editElectronicWalletInfo(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    afterRead1(file) {
      this.$commonMethod.showLoading();
      var formData = new FormData();
      formData.append("file", file.file);
      this.$api.system
        .uploadImgFile(formData)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: this.$t.meta.uploadSuccess,
            type: "success",
          });
          this.form.ElectronicWalletQrCode = res.data;
          this.$commonMethod.hideLoading();
        })
        .catch(() => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: this.$t.meta.uploadFail,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.workbenchBank {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
